import { useEffect, useState } from "react";
import { PlayCircle } from "lucide-react";
import { api } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { JurBadge } from "@/components/copiloto/EstadoBadge";

export const FaqList = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/faq").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  if (!items) return <div className="text-sm text-slate-500">Cargando…</div>;
  if (!items.length) {
    return <div className="text-sm text-slate-500" data-testid="faq-empty">Aún no hay preguntas publicadas.</div>;
  }
  return (
    <Accordion type="single" collapsible className="bg-white rounded-2xl border border-[#E2DCD2] px-4" data-testid="faq-list">
      {items.map((f) => (
        <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${f.id}`}>
          <AccordionTrigger className="text-left text-sm font-semibold text-slate-900">
            <span className="flex flex-col gap-1">
              <span>{f.pregunta}</span>
              <span className="flex gap-2">
                {f.categoria && <span className="text-[10px] uppercase tracking-widest text-slate-500">{f.categoria}</span>}
                <JurBadge jur={f.jurisdiccion} referencia={f.referencia_cdmx} />
              </span>
            </span>
          </AccordionTrigger>
          <AccordionContent className="text-sm text-slate-700 whitespace-pre-line">
            {f.respuesta}
            {f.fuente && <div className="mt-2 text-xs text-[#1F4640]"><b>Fuente: </b>{f.fuente}</div>}
            {f.url_contenido && (
              <a href={f.url_contenido} target="_blank" rel="noopener noreferrer" className="mt-2 inline-flex items-center gap-1 text-xs font-semibold text-[#1E3A5F] hover:underline">
                <PlayCircle className="w-4 h-4" /> Ver video
              </a>
            )}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
